/**
 * orval generated query/mutation hook의 `select` 옵션에 사용하는 헬퍼.
 * 호출처에서 `{ query: { select: selectData } }` 형태로 응답 wrapper(`{ data: T }`)에서
 * 페이로드만 꺼낸다.
 */
export const selectData = <T>(response: { data: T }): T => response.data;
